import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { TextField, Snackbar, Alert } from "@mui/material";
import axios from "axios";
import { API_BASE_URL } from './config';
import "./login.css";

const ResetPassword = () => {
  const [resetPassword, setResetPassword] = useState("");
  const [cheakPassword, setCheakPassword] = useState("");
  const [token, setToken] = useState(null);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const navigate = useNavigate();
  const [searchParams] = useSearchParams(); // 取得 URL 參數

  useEffect(() => {
    const tokenFromURL = searchParams.get("token");
    if (!tokenFromURL) {
      setError("無效的重設密碼連結");
    } else {
      setToken(tokenFromURL);
    }
  }, [searchParams]);

  const handleResetPassword = async () => {
    if (!resetPassword || !cheakPassword) {
      setError("請輸入新密碼並確認密碼");
      return;
    }
    if (resetPassword !== cheakPassword) {
      setError("兩次輸入的密碼不一致");
      return;
    }
    if (!token) {
      setError("無效的重設密碼連結");
      return;
    }

    try {
      const response = await axios.post(`${API_BASE_URL}/reset-password`, {
        token,
        newPassword: resetPassword,
      });

      setSuccessMessage(response.data.message);
      setTimeout(() => {
        navigate("/login"); // 3 秒後導回登入頁
      }, 3000);
    } catch (error) {
      setError(error.response?.data?.message || "重設密碼失敗");
    }
  };
  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    setError(null);
    setSuccessMessage(null);
  };

  return (
    <div className="responsive-container">
      <div className="reset-bg">

      <Snackbar open={Boolean(error)} autoHideDuration={5000} onClose={handleClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
          <Alert onClose={handleClose} severity="error">
            {error}
          </Alert>
        </Snackbar>

        <Snackbar open={Boolean(successMessage)} autoHideDuration={5000} onClose={handleClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
          <Alert onClose={handleClose} severity="success">
            {successMessage}
          </Alert>
        </Snackbar>

        <h2>重設密碼</h2>

        <div className="form-group">
          <div className="input-group">
            <TextField
              label="新密碼"
              variant="filled"
              type="password"
              sx={{
                width: '100%',
                '& .MuiFilledInput-root': { minHeight: '45px' }, // 設定最小高度
                '& .MuiFilledInput-input': { padding: '5px 10px 0 10px' }, // 上左下右

                '& .MuiFilledInput-root:before': { borderBottom: 'none' },
                '& .MuiFilledInput-root:hover:before': { borderBottom: 'none' },
                '& .MuiInput-underline:hover:not(.Mui-disabled):before': { borderBottom: 'none' },

                '& input:-webkit-autofill': {
                  backgroundColor: 'transparent !important',
                  WebkitBoxShadow: '0 0 0px 1000px transparent inset',
                  transition: 'background-color 5000s ease-in-out 0s',
                },
                '& input:-webkit-autofill:focus': {
                  backgroundColor: 'transparent !important',
                },

                // 調整浮動標籤的位置
                '& .MuiInputLabel-root': { top: '0px' },
                '& .MuiInputLabel-shrink': { transform: 'translate(10px, 2px) scale(0.7)' } // 左右、上下 位置
              }}
              onChange={(e) => setResetPassword(e.target.value)}
            />
          </div>


          <div className="input-group">
            <TextField
              label="確認密碼"
              variant="filled"
              type="password"
              sx={{
                width: '100%',
                '& .MuiFilledInput-root': { minHeight: '45px' }, // 設定最小高度
                '& .MuiFilledInput-input': { padding: '5px 10px 0 10px' }, // 上左下右

                '& .MuiFilledInput-root:before': { borderBottom: 'none' },
                '& .MuiFilledInput-root:hover:before': { borderBottom: 'none' },
                '& .MuiInput-underline:hover:not(.Mui-disabled):before': { borderBottom: 'none' },

                '& input:-webkit-autofill': {
                  backgroundColor: 'transparent !important',
                  WebkitBoxShadow: '0 0 0px 1000px transparent inset',
                  transition: 'background-color 5000s ease-in-out 0s',
                },
                '& input:-webkit-autofill:focus': {
                  backgroundColor: 'transparent !important',
                },

                // 調整浮動標籤的位置
                '& .MuiInputLabel-root': { top: '0px' },
                '& .MuiInputLabel-shrink': { transform: 'translate(10px, 2px) scale(0.7)' } // 左右、上下 位置
              }}
              onChange={(e) => setCheakPassword(e.target.value)}
            />
          </div>

          <div className='button-group'>
            <button className="btn btn-login" onClick={handleResetPassword}>提交</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;